/* eslint-disable import/no-default-export */
import { State } from 'app/gamma/src/modules';
import { connect } from 'react-redux';
import { getMe, getMemberById, hasGold } from 'app/gamma/src/selectors/members';
import { MemberModel } from 'app/gamma/src/types';

import { MemberAvatar, MemberAvatarProps } from './member-avatar';

interface MemberAvatarContainerProps
  extends Pick<
      MemberAvatarProps,
      'className' | 'size' | 'onClick' | 'gold' | 'hoverable' | 'admin'
    > {
  idMember?: string;
  member?: MemberModel;
}

const mapStateToProps = (
  state: State,
  ownProps: MemberAvatarContainerProps,
) => {
  const { idMember } = ownProps;
  let { member } = ownProps;

  if (idMember) {
    member = getMemberById(state, idMember);
  } else if (!member) {
    member = getMe(state);
  }

  if (member) {
    const { name, username, avatars, initials } = member;
    return {
      idMember: member.id,
      name,
      username,
      initials,
      avatars: avatars || undefined,
      gold:
        typeof ownProps.gold === 'boolean'
          ? ownProps.gold
          : hasGold(state, member),
    };
  }

  return {};
};

export default connect(mapStateToProps)(MemberAvatar);
